import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const Delete = ({ confirmDelete, closeDialog, loading }) => {
  return (
    <>
      <DialogTitle>Confirmer la suppression</DialogTitle>
      <DialogContent>
        Voulez-vous vraiment poursuivre la suppression ?
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={closeDialog} disabled={loading}>
          Annuler
        </Button>
        <LoadingButton onClick={confirmDelete} loading={loading}>
          Oui
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default Delete;
